export default __webpack_public_path__ + "static/media/user.f65854c5.svg";